import React from 'react';
import { ManifestationCard as ManifestationCardType } from '../data/manifestations';
import { LazyImage } from './LazyImage';

interface ManifestationCardProps {
  card: ManifestationCardType;
}

export const ManifestationCard: React.FC<ManifestationCardProps> = ({ card }) => {
  return (
    <div className="relative h-full overflow-hidden rounded-lg shadow-md transform transition-transform hover:scale-102">
      <div className="absolute inset-0 bg-gradient-to-t from-purple-900/70 to-transparent z-10" />
      <LazyImage
        src={card.imageUrl} 
        alt="Manifestation background"
        className="absolute inset-0 w-full h-full object-cover"
        placeholder="Loading inspiration..."
        width={400}
        height={300}
      />
      <div className="relative z-20 h-full flex items-center justify-center p-6 text-center">
        <p className="text-2xl font-semibold text-white leading-tight">
          {card.text}
        </p>
      </div>
    </div>
  );
};